import React, { Component } from 'react';
import { List } from 'immutable';
import { injectIntl, FormattedMessage } from 'react-intl';

import { compose } from 'redux';

import { connect } from 'react-redux';
import { rtlEnable, userFeaturesSelector } from 'domain/env';
import { Page } from 'react-pdf';
import PdfViewerDocument from 'components/PdfViewer';
import { getRotateByDocID } from 'lib/pdfHelpers';
import { editableDocSelector, currentCompanyIdSelector } from 'domain/documents';

import { documentSplit } from 'domain/documents/documentsActions';

import { storage } from 'lib/storage';
import { createMemoFn, withPropsCollector } from 'lib/propHelpers';
import { withApiToken } from 'lib/apiTokenKeeper';
import withConfirm from 'hoc/withConfirm';

import { CONFIGURABLE_API_ENDPOINT } from 'lib/apiHelpers';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import Paper from '@mui/material/Paper';
import EditPreview from './EditPreview';
import DocumentPages from './DocumentPages';
import SplitOptions from './SplitOptions';
import Tooltip from 'components/mui/Tooltip';
import { PageRoot, PreviewButton } from 'pages/common/Dialog/DialogDocumentEdit/StyledComponents';

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

const MAX_BADGE_COUNT = 10000;

const baseUrl = CONFIGURABLE_API_ENDPOINT || '';

function getSelectedList(array, item) {
  if (array.indexOf(item) + 1) return array.filter((number) => number !== item);
  return [...array, item];
}

function setIdx(array) {
  return array.map((item, idx) => ({ ...item, idx }));
}

function getTooltipText(cutted = false) {
  return {
    id: cutted ? 'documentEdit.tooltip.cutted' : 'documentEdit.tooltip.cut',
    defaultMessage: cutted ? 'Press to unite documents' : 'Press to split document',
  };
}

class DocumentEdit extends Component {
  constructor(props) {
    super(props);
    // https://github.com/wojtekmaj/react-pdf/wiki/Frequently-Asked-Questions#react-pdf-reloads-itself-with-every-render-whats-going-on

    this.viewportRef = React.createRef();

    this.state = {
      selected: [],
      changeable: {
        removed: [],
        pages: [],
        separated: [],
      },
      initialPages: [],
      changes: [],
      reverted: [],
      isLoading: false,
      embededRotate: {},
      splitOptionValue: storage().splitOptions().get() || 'add',
      pagesBoundary: [],
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyUndo);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyUndo);
  }

  onSelect = (event, pageNumber) => {
    const { selected } = this.state;
    if (event.ctrlKey || event.metaKey) {
      this.setState({ selected: getSelectedList(selected, pageNumber) });
      return;
    }

    this.setState({ selected: selected.indexOf(pageNumber) + 1 ? [] : [pageNumber] });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    const {
      changeable: { pages },
    } = this.state;
    this.onDndDrop(pages[oldIndex], newIndex);
  };

  onDndDrop = (draggablePage, droppedPosition) => {
    const { changeable } = this.state;

    if (draggablePage && typeof droppedPosition === 'number') {
      this.saveChanges(() => {
        const pages = [...changeable.pages];

        let separated = changeable.separated;
        const idx = droppedPosition <= 0 ? 0 : droppedPosition || 1;
        pages.splice(draggablePage.idx, 1);
        pages.splice(idx, 0, { number: draggablePage.number });
        if (separated.indexOf(draggablePage.number) + 1) {
          separated = separated.map((item) => {
            if (item === draggablePage.number) return pages[draggablePage.idx].number;
            return item;
          });
        }
        this.setState({
          changeable: {
            ...changeable,
            pages: setIdx(pages),
            separated,
          },
        });
      });
    }
  };

  onRemove = () => {
    const { selected, changeable } = this.state;
    const { pages, removed } = changeable;

    this.saveChanges(() =>
      this.setState({
        selected: [],
        changeable: {
          ...changeable,
          pages: setIdx(pages.filter((item) => selected.indexOf(item.number) < 0)),
          removed: [...removed, ...selected],
        },
      }),
    );
  };

  onSave = () => {
    const {
      document: { documentID },
      onClose,
      documentSplit: docSplit,
    } = this.props;
    const {
      splitOptionValue,
      changeable: { pages, separated },
    } = this.state;

    const spages = [
      0,
      ...pages.filter((item) => separated.indexOf(item.number) + 1).map((item) => item.idx + 1),
      pages.length,
    ];
    const newdocs = spages
      .map((split, idx) => [...pages].splice(split, spages[idx + 1] - split).map((item) => item.number - 1))
      .filter((array) => array.length > 0)
      .map((array) => ({ pages: array }));

    this.setState({ isLoading: true });
    new Promise((resolve, reject) => {
      docSplit({
        documentID,
        newdocs,
        resolve,
        reject,
        splitOptions: splitOptionValue,
      });
    })
      .then(() => {
        onClose();
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  onSaveClick = () => {
    const {
      confirm,
      intl: { formatMessage },
    } = this.props;

    const action = () => {
      this.onSave();
    };

    this.isAllowAutoConfirm()
      ? action()
      : confirm({
          title: formatMessage({
            id: 'documentEdit.confirm.title',
            defaultMessage: 'Are you sure?',
          }),
          description: formatMessage({
            id: 'documentEdit.confirm.placeholder',
            defaultMessage: 'Are you sure you want to save current changes?',
          }),
          confirmationText: formatMessage({
            id: 'documentEdit.confirm.yes',
            defaultMessage: 'Yes',
          }),
          cancellationText: formatMessage({
            id: 'documentEdit.confirm.cancel',
            defaultMessage: 'No',
          }),
        }).then(() => {
          action();
        });
  };

  onOpenPreview = (previewPageNumber) => (e) => {
    e.stopPropagation();
    this.setState({ previewPageNumber });
  };

  onClosePreview = () => {
    this.setState({ previewPageNumber: null });
  };

  onRenderDocSuccess = (pageIndex) => (docRender) => {
    this.setState(({ embededRotate }) => ({
      embededRotate: { ...embededRotate, [pageIndex]: docRender.rotate },
    }));
  };

  get disabled() {
    const {
      changeable: { separated, pages },
      initialPages,
      isLoading,
    } = this.state;
    const changes = separated.length < 1;
    const isSamePages = List(initialPages).equals(List(pages));
    const noChanges = [changes, isSamePages].filter((check) => !check).length < 1;
    return noChanges || isLoading;
  }

  get getPageHeight() {
    const viewport = this.viewportRef.current;
    const { height } = viewport.getBoundingClientRect();

    const thumbHeight = (height - 120) / 2;

    if (thumbHeight < 240) {
      return 240;
    }

    if (thumbHeight > 800) {
      return 800;
    }

    return thumbHeight;
  }

  getLink = createMemoFn(
    () => {
      const {
        apiToken,
        companyId,
        document: { documentID },
      } = this.props;
      return { apiToken, companyId, documentID };
    },
    ({ apiToken, companyId, documentID }) => {
      const url =
        apiToken && documentID && companyId
          ? `${baseUrl}/v2/3/getDocument?documentID=${documentID}&dokkaToken=${apiToken}&companyId=${companyId}&markAsOld=0&original=true`
          : '';
      return url ? { url } : null;
    },
  );

  handleKeyUndo = (event) => {
    if (event.code === 'KeyZ' && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      const execute = event.shiftKey ? this.redo : this.undo;
      execute();
    }
  };

  handleOnLoad = (pdf) => {
    const { numPages } = pdf;
    const { changeable } = this.state;

    const pages = Array.from({ length: numPages }).map((item, idx) => ({ number: idx + 1, idx }));
    const pagesBoundary = pages.map(() => ({ height: this.getPageHeight }));

    this.setState({
      changeable: {
        ...changeable,
        pages,
      },
      initialPages: pages,
      pagesBoundary,
    });
  };

  onSelectSplitOption = (e) => {
    this.setState({ splitOptionValue: e.target.value }, () => storage().splitOptions().set(e.target.value));
  };

  getRotate = (pageIndex) => {
    const {
      document: { viewinfo, documentID },
    } = this.props;
    const { embededRotate } = this.state;

    const embRotate = embededRotate[pageIndex] | 0;
    const rs = getRotateByDocID(documentID) || {};
    const lsRotate = rs[pageIndex];
    const rotate = typeof lsRotate === 'number' ? lsRotate : viewinfo.rotations[pageIndex] || 0;
    return (rotate + embRotate) % 360;
  };

  separatePages = (number, event) => {
    const {
      changeable,
      changeable: { separated },
    } = this.state;
    event.stopPropagation();

    this.saveChanges(() => {
      this.setState({
        changeable: { ...changeable, separated: getSelectedList(separated, number) },
      });
    });
  };

  separateAllPages = () => {
    const {
      changeable,
      changeable: { pages },
    } = this.state;
    const pageNumbers = pages.map((page) => page.number);

    this.saveChanges(() => {
      this.setState({ changeable: { ...changeable, separated: pageNumbers } });
    });
  };

  saveChanges = (cb) => {
    const { changeable } = this.state;
    this.setState({ changes: [changeable], reverted: [] }, cb);
  };

  undo = () => {
    const { changes, changeable } = this.state;
    if (changes.length > 0) {
      const [tail] = changes;
      this.setState({
        changeable: tail,
        changes: [],
        reverted: [changeable],
      });
    }
  };

  redo = () => {
    const { reverted, changeable } = this.state;
    if (reverted.length > 0) {
      const [tail] = reverted;
      this.setState({
        changeable: tail,
        reverted: [],
        changes: [changeable],
      });
    }
  };

  isAllowAutoConfirm = () => {
    const { userFeatures } = this.props;
    return !userFeatures.get('modal', true);
  };

  handlePageLoad = (page) => {
    const { pagesBoundary } = this.state;
    const { height, width, _pageIndex } = page;
    const ratio = width / height;
    const isHorizontal = ratio > 1;
    const rotate = this.getRotate(_pageIndex);

    if (isHorizontal) {
      const currentPagesBoundary = pagesBoundary.map((boundary, index) => {
        if (_pageIndex === index && (rotate === 0 || rotate === 180)) {
          return {
            ...boundary,
            width: 300,
          };
        }
        return boundary;
      });

      this.setState({ pagesBoundary: currentPagesBoundary });
    }
  };

  render() {
    const { onClose, theme } = this.props;

    const {
      changes,
      selected,
      changeable: { pages, separated },
      reverted,
      previewPageNumber,
      splitOptionValue,
      pagesBoundary,
    } = this.state;

    const link = this.getLink();

    const disableSplitAll = pages.length === 0 || separated.length === pages.length;

    return (
      <Dialog
        open={Boolean(true)}
        fullWidth
        slotProps={{ paper: { sx: { width: '100%', maxWidth: '100%', m: 0, height: '90vh' } } }}
      >
        <DialogContent ref={this.viewportRef}>
          {link && (
            <PdfViewerDocument file={link} onLoadSuccess={this.handleOnLoad}>
              <DocumentPages
                items={pages}
                axis="xy"
                distance={10}
                onSortEnd={this.onSortEnd}
                helperClass="page-is-dragging"
              >
                {(page, idx) => (
                  <PageRoot
                    component="div"
                    color="primary"
                    max={MAX_BADGE_COUNT}
                    badgeContent={idx + 1}
                    onClick={(event) => this.onSelect(event, page.number)}
                    style={{ height: this.getPageHeight }}
                    dir="ltr"
                  >
                    <Paper
                      variant="outlined"
                      sx={{
                        borderRadius: 2,
                        height: '100%',
                        overflow: 'hidden',
                        ...(selected.includes(page.number) && {
                          filter: 'brightness(0.8)',
                          boxShadow:
                            '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
                        }),
                      }}
                    >
                      <PreviewButton onClick={this.onOpenPreview(page.number)} className="preview-eye-icon">
                        <RemoveRedEyeOutlinedIcon />
                      </PreviewButton>
                      <Page
                        pageNumber={page.number}
                        renderTextLayer={false}
                        renderAnnotations={false}
                        onRenderSuccess={this.onRenderDocSuccess(idx)}
                        onLoadSuccess={this.handlePageLoad}
                        renderAnnotationLayer={false}
                        rotate={this.getRotate(page.number - 1)}
                        {...pagesBoundary[page.number - 1]}
                      />
                    </Paper>
                    {idx < pages.length - 1 && (
                      <Tooltip t={getTooltipText(separated.includes(page.number))}>
                        <Divider
                          orientation="vertical"
                          component="button"
                          sx={{
                            cursor: 'pointer',
                            position: 'absolute',
                            left: '100% /* @noflip */',
                            top: 0,
                            backgroundColor: 'transparent',
                            '&:before, &:after': {
                              borderLeftStyle: 'dashed',
                              borderLeftColor: (theme) =>
                                separated.indexOf(page.number) + 1
                                  ? theme.palette.primary.main
                                  : theme.palette.grey[500],
                            },
                          }}
                          onClick={(event) => this.separatePages(page.number, event)}
                        >
                          <ContentCutIcon
                            sx={{
                              transform: 'rotate(90deg)',
                              color: (theme) =>
                                separated.indexOf(page.number) + 1
                                  ? theme.palette.primary.main
                                  : theme.palette.grey[500],
                            }}
                          />
                        </Divider>
                      </Tooltip>
                    )}
                  </PageRoot>
                )}
              </DocumentPages>
              {previewPageNumber && (
                <EditPreview pageNumber={previewPageNumber} getRotate={this.getRotate} onClose={this.onClosePreview} />
              )}
            </PdfViewerDocument>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            bgcolor: 'grey.50',
            borderTop: 1,
            borderColor: 'grey.200',
          }}
        >
          <Stack direction="row" flex="1" alignItems="center">
            <Stack flex="1" direction="row" justifyContent="start">
              <SplitOptions onSelect={this.onSelectSplitOption} value={splitOptionValue} theme={theme} />
            </Stack>
            <Stack flex="1" direction="row" justifyContent="center" spacing={1}>
              <Button
                variant="outlined"
                type="button"
                startIcon={<ContentCutIcon />}
                disabled={disableSplitAll}
                onClick={this.separateAllPages}
              >
                <FormattedMessage id="documentEdit.splitAll" defaultMessage="Split all" />
              </Button>
              <Stack direction="row" spacing={0.5}>
                <IconButton disabled={changes.length < 1} onClick={this.undo}>
                  <UndoIcon />
                </IconButton>
                <Divider orientation="vertical" variant="middle" flexItem />
                <IconButton onClick={this.redo} disabled={reverted.length < 1}>
                  <RedoIcon />
                </IconButton>
              </Stack>
              <Button
                variant="outlined"
                type="button"
                color="error"
                startIcon={<DeleteOutlineIcon />}
                disabled={selected.length < 1}
                onClick={this.onRemove}
              >
                <FormattedMessage id="documentEdit.remove" defaultMessage="Remove" />
              </Button>
            </Stack>
            <Stack flex="1" direction="row" justifyContent="end" spacing={2}>
              <Button variant="outlined" onClick={onClose}>
                <FormattedMessage id="documentEdit.cancel" defaultMessage="Cancel" />
              </Button>
              <Button disabled={this.disabled} onClick={this.onSaveClick}>
                <FormattedMessage id="documentEdit.save" defaultMessage="Save" />
              </Button>
            </Stack>
          </Stack>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => ({
  companyId: currentCompanyIdSelector(state),
  direction: rtlEnable(state) ? 'rtl' : 'ltr',
  document: editableDocSelector(state),
  userFeatures: userFeaturesSelector(state),
});

const mapDispatchToProps = {
  documentSplit,
};

export default compose(
  withApiToken,
  withConfirm,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
  withPropsCollector,
)(DocumentEdit);
